<template>
  <v-container
    fluid
    class="py-0"
  >
    <top-bar
      :header="needsAccountInfo ? 'Welcome.  Let\'s get started...' : `Welcome, ${user.firstname}!`"
      no-breadcrumb
    />
    <v-row
      v-if="$root.$restrict({ 'user.usertype': 'C' })"
    >
      <v-col
        cols="12"
        md="9"
      >
        <div
          v-if="initialLoading"
          class="text-center"
        >
          <v-progress-circular
            color="primary"
            indeterminate
          />
        </div>
        <v-row
          v-else
          class="mb-4"
        >
          <v-col
            v-if="$vuetify.breakpoint.smAndDown"
            cols="12"
          >
            <mobile-menu />
          </v-col>
          <v-col
            v-if="needsAccountInfo"
            cols="12"
          >
            <account-info-form />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <address-card
              v-if="billingAddress"
              :value="billingAddress"
              title="Billing Address"
            />
            <v-card
              v-else
              class="elevation-1 pa-3 d-flex align-center justify-center"
              style="height: 206px;"
              :to="{ name: 'AddressEditor', params: { addressId: 'new' }, query: { default_b: true } }"
            >
              <v-icon small>fa fa-plus</v-icon> <span class="ml-2">Billing Address</span>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <address-card
              v-if="shippingAddress"
              :value="shippingAddress"
              title="Shipping Address"
            />
            <v-card
              v-else
              class="elevation-1 pa-3 d-flex align-center justify-center"
              style="height: 206px;"
              :to="{ name: 'AddressEditor', params: { addressId: 'new' }, query: { default_s: true } }"
            >
              <v-icon small>fa fa-plus</v-icon> <span class="ml-2">Shipping Address</span>
            </v-card>
          </v-col>
        </v-row>

        <!-- ORDERS -->
        <order-card
          class="mb-6"
          v-for="orderRecord in orderRecordsSorted"
          :key="orderRecord.orderid"
          :value="orderRecord"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <account-manager />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { Address, Order } from '@/models'
import AddressCard from '@/views/AddressBook/AddressCard'
import OrderCard from '@/views/Orders/OrderCard'
import AccountInfoForm from '@/views/AccountInfo/AccountInfoForm'
import MobileMenu from './MobileMenu'
import { orderBy } from 'lodash'

export default {
  name: 'Home',
  mixins: [
    Order.mixin()
  ],
  components: {
    AccountInfoForm,
    AddressCard,
    OrderCard,
    MobileMenu
  },
  data () {
    return {
      initialLoading: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    addressRecords () {
      return Address.all()
    },
    shippingAddress () {
      return this.addressRecords.find(r => r.default_s === 'Y')
    },
    billingAddress () {
      return this.addressRecords.find(r => r.default_b === 'Y')
    },
    orderRecords () {
      return Order.all()
    },
    orderRecordsSorted () {
      return orderBy(this.orderRecords, ['date'], ['desc'])
    },
    needsAccountInfo () {
      return !(this.user && this.user.firstname && this.user.lastname && this.user.email)
    }
  },
  async created () {
    this.initialLoading = true
    const promises = []
    if (!this.addressRecords.length) {
      promises.push(Address.fetchMany())
    }
    if (!this.orderRecords.length) {
      promises.push(this.orderFetchMany({
        params: {
          type: 'OPEN'
        }
      }))
    }
    // More to come
    try {
      await Promise.all(promises)
      this.initialLoading = false
    } catch (e) {
      this.initialLoading = false
      throw e
    }
  }
}
</script>
